import { render, staticRenderFns } from "./Passengers.vue?vue&type=template&id=a2718bac"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports